import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@tt/ui';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Spinner from '../../Spinner/Spinner';

import {
  possibleSmWidth,
  possibleTypes,
  possibleWidth,
  sizes,
  variants,
} from './constants';

import styles from './Button.module.scss';

const Button = ({
  children,
  to,
  href,
  width,
  smWidth,
  className,
  loading,
  icon,
  type = 'primary',
  variant = 'fill',
  iconPosition = 'start',
  size = 'md',
  htmlType = 'button',
  ...rest
}) => {
  let content = (
    <>
      {icon ? <Icon name={icon} /> : null}
      {children}
    </>
  );
  if (loading) {
    content = <Spinner />;
  }

  const widthToUse = width && possibleWidth.includes(width) ? width : 'hug';

  const cn = cx(
    styles['ds-button'],
    styles[`type-${type}`],
    styles[`variant-${variant}`],
    styles[`size-${size}`],
    styles[`width-${widthToUse}`],
    styles[`icon-position-${iconPosition}`],
    {
      [styles.loading]: loading,
      [styles[`sm-width-${smWidth}`]]:
        !!smWidth && possibleSmWidth.includes(smWidth),
    },
    className,
  );

  if (to) {
    return (
      <Link className={cn} to={to} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a className={cn} href={href} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button type={htmlType} className={cn} {...rest}>
      {content}
    </button>
  );
};

Button.propTypes = {
  type: PropTypes.oneOf(possibleTypes),
  variant: PropTypes.oneOf(variants),
  size: PropTypes.oneOf(sizes),
  width: PropTypes.oneOf(possibleWidth),
  smWidth: PropTypes.oneOf(possibleSmWidth), // small screen width
  children: PropTypes.node,
  to: PropTypes.string,
  href: PropTypes.string,
  loading: PropTypes.bool,
  htmlType: PropTypes.oneOf(['submit', 'reset', 'button']),
  className: PropTypes.string,
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(['start', 'end']),
};

export default Button;
